// @ts-nocheck
import {
  Component, OnInit, Input, Output, EventEmitter,
} from '@angular/core';
import { P } from '../../ui-kit';
import { UIKitIconRegistry } from '../../icon/icon.registry';
import { plusIcon } from '../../icon/plus/plus';
import { heartIcon } from '../../icon/heart/heart';
import { infoIcon } from '../../icon/info/info';
import { diamondIcon } from '../../icon/diamond/diamond';
import { thumbDownIcon } from '../../icon/thumb-down/thumb-down';
import { cursorIcon } from '../../icon/cursor/cursor';
import { Required } from '../../decorators/required';

@Component({
  selector: 'lib-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss'],
})
export class ThumbnailComponent implements OnInit {
  @Input() @Required data: P.Listing;

  @Input() @Required type: 'minimal' | 'compact' | 'liked' | 'dislike' | 'admin';

  @Input() isRecommended: boolean;

  @Input() isFavourite: boolean;

  @Output() action: EventEmitter<any> = new EventEmitter();

  @Output() thumbdown: EventEmitter<any> = new EventEmitter();

  @Output() viewlisting: EventEmitter<any> = new EventEmitter();

  toggle: P.Dictionary<boolean> = {};

  constructor(iconRegistry: UIKitIconRegistry) {
    iconRegistry.registerIcons([plusIcon, heartIcon, thumbDownIcon, infoIcon, diamondIcon, cursorIcon]);
  }

  ngOnChanges(): void {
    if (this.type === 'compact') {
      this.toggle.isDislike = true;
      this.toggle.isInfo = true;
      this.toggle.isHeart = true;
    } else if (this.type === 'like') {
      this.toggle.isDetails = true;
      this.toggle.isHeart = true;
    } else if (this.type === 'liked') {
      this.toggle.isDetails = true;
      this.toggle.isHeart = true;
      this.toggle.isHeartActive = true;
    } else if (this.type === 'dislike') {
      this.toggle.isDetails = true;
      this.toggle.isHeart = true;
      this.toggle.isDislike = true;
    } else if (this.type === 'admin') {
      this.toggle.isDetails = true;
      this.toggle.isOffset = true;
      this.toggle.isPlus = true;
    }
  }

  thumbnailAction(event?: MouseEvent | TouchEvent) {
    if (event) {
      event.stopImmediatePropagation();
    }
    this.action.emit(this.data);
  }

  thumbDownClicked($event) {
    $event.stopImmediatePropagation();
    this.thumbdown.emit(this.data);
  }

  viewListing() {
    this.viewlisting.emit(this.data);
  }
}
